import type { Profile } from '../services/auth';

import i18n from './config';
import type { SupportedLanguages } from './constants';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './constants';

const SupportedLangRegistry = new Set<unknown>(SUPPORTED_LANGUAGES);

function isSupportedLanguage(value?: unknown): value is SupportedLanguages {
  return SupportedLangRegistry.has(value);
}

export const getUserLanguage = (userLanguage: Profile['language'] = i18n.language): SupportedLanguages => {
  if (!userLanguage) {
    return DEFAULT_LANGUAGE;
  }
  const language = userLanguage.toUpperCase();

  if (isSupportedLanguage(language)) {
    return language;
  }

  return DEFAULT_LANGUAGE;
};
